import React from "react";

const NotAvailable = () => <span className="not-available">NOT AVAILABLE</span>;

export { NotAvailable };
